<template>
  <div class="footer">
    <van-tabbar v-model="active" route active-color="#FC6E09">
      <van-tabbar-item  replace to="/homeC">
        <span>首页</span>
        <template #icon="props">
          <svg-icon :icon-class="props.active ? icon.active : icon.inactive"></svg-icon>
          <!-- <van-image  width="20" height="20" :src="props.active ? icon.active1 : icon.inactive1" /> -->
        </template>
      </van-tabbar-item>
      <van-tabbar-item  replace to="/productTC">
        <span>产品库</span>
        <template #icon="props">
          <svg-icon :icon-class="props.active ? icon.active1 : icon.inactive1"></svg-icon>
          <!-- <van-image  width="20" height="20" :src="props.active ? icon.active1 : icon.inactive1" /> -->
        </template>
      </van-tabbar-item>
      <van-tabbar-item  replace to="/informationC">
        <span>消息</span>
        <template #icon="props">
          <svg-icon :icon-class="props.active ? icon.active3 : icon.inactive3"></svg-icon>
          <!-- <van-image  width="20" height="20" :src="props.active ? icon.active1 : icon.inactive1" /> -->
        </template>
      </van-tabbar-item>
      <van-tabbar-item  replace to="/mineTC">
        <span>我的</span>
        <template #icon="props">
          <svg-icon :icon-class="props.active ? icon.active2 : icon.inactive2"></svg-icon>
          <!-- <van-image  width="20" height="20" :src="props.active ? icon.active2 : icon.inactive2" /> -->
        </template>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>
<script>
export default {
  data() {
    return {
      active: 0,
      icon: {
        active:'foot_home1',
        inactive: 'foot_home',
        active1: 'foot_product',
        inactive1:'foot_product1',
        active2: 'foot_wode1',
        inactive2: 'foot_wode',
        active3: 'foot_info1',
        inactive3: 'foot_info',
      }
    };
  },
};
</script>
<style lang="less" scoped>
.footer {
  /* width: 100%;
  height: 80px;
  position: fixed;
  bottom: 0;
  border: 1px solid; */
  // padding-bottom:constant(safe-area-inset-bottom); /* 兼容 iOS < 11.2 */
  // padding-bottom:env(safe-area-inset-bottom);/* 兼容 iOS >= 11.2 */
  .svg-icon{
    width: 20;
    height: 20px;
  }
}

.van-tabbar{
 height: 49px;
}
.van-tabbar-item--active {
  color: #FC6E09;
}
</style>